import React from "react";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { hostUI } from "../../../../configuraciones";
import { TIPOS_DOCUMENTO_RANGO } from "./ModalDocumentosRangoHolograma";

/**
 * Bloque reutilizable dentro de cada tarjeta de SALIDA de un rango de hologramas.
 * Diferenciado visualmente (color Azul Cian `#0284C7`) de los documentos del rango (color Verde `#16A34A`)
 * para distinguir claramente entre:
 *   - Documentos de la Salida (Certificado de Producto Envasado, Informe de Servicio, Otro)
 *   - Documentos del Rango completo
 */
const DocumentosDeLaSalida = ({
  salida,
  rango = null,
  onChange,
  onOpenModal = null,
  origen = "salida_holograma"
}) => {
  const idSalida = Number(salida?.id_salida || salida?.id);
  const esGuardada = Number.isInteger(idSalida) && idSalida > 0;
  const docsGuardados = Array.isArray(salida?.documentos) ? salida.documentos : [];
  const pendientes = Array.isArray(salida?.documentosPendientes) ? salida.documentosPendientes : [];

  const setPendientes = (next) => {
    if (onChange) {
      onChange({ ...salida, documentosPendientes: next });
    }
  };

  const agregarFilaPendiente = () => {
    setPendientes([
      ...pendientes,
      {
        tipo_documento: "certificado_producto_envasado",
        nombre_documento: "",
        observaciones: "",
        file: null,
        origen_documento: origen
      }
    ]);
  };

  const actualizarPendiente = (idx, patch) => {
    setPendientes(pendientes.map((item, i) => (i === idx ? { ...item, ...patch } : item)));
  };

  const quitarPendiente = (idx) => {
    setPendientes(pendientes.filter((_, i) => i !== idx));
  };

  const labelStyle = {
    display: "block",
    fontSize: "11px",
    fontWeight: 700,
    color: "#0C4A6E",
    marginBottom: "3px"
  };

  const inputStyle = {
    width: "100%",
    padding: "6px 9px",
    borderRadius: "6px",
    border: "1px solid #7DD3FC",
    fontSize: "12px",
    boxSizing: "border-box",
    background: "#fff"
  };

  return (
    <div
      style={{
        marginTop: "8px",
        padding: "8px 10px",
        background: "#F0F9FF",
        border: "1px dashed #38BDF8",
        borderRadius: "8px"
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: "8px",
          flexWrap: "wrap"
        }}
      >
        <div
          style={{
            fontSize: "11.5px",
            fontWeight: 700,
            color: "#0369A1",
            display: "flex",
            alignItems: "center",
            gap: "6px",
            flexWrap: "wrap"
          }}
        >
          <span
            style={{
              background: "#0284C7",
              color: "#fff",
              borderRadius: "4px",
              padding: "1px 6px",
              fontSize: "10px",
              fontWeight: 800,
              letterSpacing: "0.02em"
            }}
          >
            SALIDA
          </span>
          <LocalShippingIcon style={{ fontSize: 15, color: "#0284C7" }} />
          <span>Documentos de esta salida (opcional): Certificado de Producto Envasado / Informe / Otros</span>
          {(docsGuardados.length > 0 || pendientes.length > 0) && (
            <span
              style={{
                background: "#E0F2FE",
                color: "#0369A1",
                border: "1px solid #7DD3FC",
                borderRadius: "999px",
                padding: "1px 8px",
                fontSize: "10.5px",
                fontWeight: 700
              }}
            >
              {docsGuardados.length + pendientes.length} archivo(s)
            </span>
          )}
        </div>

        <div style={{ display: "flex", gap: "6px", alignItems: "center" }}>
          {esGuardada && onOpenModal && (
            <button
              type="button"
              onClick={() => onOpenModal(salida, rango)}
              style={{
                background: "#0284C7",
                border: "none",
                color: "#fff",
                borderRadius: "6px",
                padding: "4px 10px",
                fontSize: "11px",
                fontWeight: 700,
                cursor: "pointer",
                display: "inline-flex",
                alignItems: "center",
                gap: "4px"
              }}
            >
              <UploadFileIcon style={{ fontSize: 13 }} />
              <span>Expediente de la Salida ({docsGuardados.length})</span>
            </button>
          )}

          {(!esGuardada || onChange) && (
            <button
              type="button"
              onClick={() => {
                if (esGuardada && onOpenModal) {
                  onOpenModal(salida, rango);
                } else {
                  agregarFilaPendiente();
                }
              }}
              style={{
                background: "#fff",
                border: "1px solid #0284C7",
                color: "#0369A1",
                borderRadius: "6px",
                padding: "4px 9px",
                fontSize: "11px",
                fontWeight: 700,
                cursor: "pointer"
              }}
            >
              + Adjuntar doc. a salida
            </button>
          )}
        </div>
      </div>

      {/* Documentos ya guardados en servidor para esta salida */}
      {docsGuardados.length > 0 && (
        <div style={{ marginTop: "7px", display: "flex", flexWrap: "wrap", gap: "6px" }}>
          {docsGuardados.map((d) => (
            <a
              key={d.id_documento}
              href={`${hostUI}bitacora-envasado/producto/salida/documentos/${d.id_documento}/ver`}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "5px",
                padding: "3px 9px",
                borderRadius: "999px",
                background: "#fff",
                border: "1px solid #7DD3FC",
                color: "#0369A1",
                fontSize: "11px",
                fontWeight: 700,
                textDecoration: "none"
              }}
              title={d.archivo_nombre_original || d.nombre_original || d.nombre_documento}
            >
              <VisibilityIcon style={{ fontSize: 13 }} />
              <span>{d.nombre_documento}</span>
            </a>
          ))}
        </div>
      )}

      {/* Archivos en cola (cuando la salida aún no se ha guardado o se agregan en línea) */}
      {pendientes.map((item, idx) => (
        <div
          key={idx}
          style={{
            marginTop: "7px",
            padding: "8px 10px",
            background: "#fff",
            border: "1px solid #BAE6FD",
            borderRadius: "7px"
          }}
        >
          <div
            style={{
              display: "grid",
              gridTemplateColumns: item.tipo_documento === "otro" ? "1.3fr 1.2fr 1.5fr auto" : "1.4fr 1.8fr auto",
              gap: "8px",
              alignItems: "end"
            }}
          >
            <div>
              <label style={labelStyle}>Tipo de documento (Salida)</label>
              <select
                value={item.tipo_documento || "certificado_producto_envasado"}
                onChange={(e) => actualizarPendiente(idx, { tipo_documento: e.target.value })}
                style={inputStyle}
              >
                {TIPOS_DOCUMENTO_RANGO.map((t) => (
                  <option key={t.id} value={t.id}>
                    {t.nombre}
                  </option>
                ))}
              </select>
            </div>

            {item.tipo_documento === "otro" && (
              <div>
                <label style={labelStyle}>Nombre del documento *</label>
                <input
                  type="text"
                  value={item.nombre_documento || ""}
                  placeholder="Ej. Guía / Factura / Pedimento"
                  onChange={(e) => actualizarPendiente(idx, { nombre_documento: e.target.value })}
                  style={inputStyle}
                />
              </div>
            )}

            <div>
              <label style={labelStyle}>Archivo (PDF, JPG, PNG)</label>
              <input
                type="file"
                accept=".pdf,.jpg,.jpeg,.png,.webp"
                onChange={(e) => {
                  const f = e.target.files && e.target.files[0] ? e.target.files[0] : null;
                  actualizarPendiente(idx, { file: f });
                }}
                style={{ ...inputStyle, padding: "4px 6px" }}
              />
            </div>

            <div>
              <button
                type="button"
                onClick={() => quitarPendiente(idx)}
                style={{
                  background: "#FEF2F2",
                  border: "1px solid #FECACA",
                  color: "#DC2626",
                  borderRadius: "6px",
                  padding: "6px 8px",
                  fontSize: "11px",
                  fontWeight: 700,
                  cursor: "pointer",
                  display: "inline-flex",
                  alignItems: "center"
                }}
                title="Quitar documento pendiente de la salida"
              >
                <DeleteOutlineIcon style={{ fontSize: 15 }} />
              </button>
            </div>
          </div>

          <div style={{ marginTop: "6px" }}>
            <input
              type="text"
              value={item.observaciones || ""}
              placeholder="Observaciones del documento de esta salida (opcional)"
              onChange={(e) => actualizarPendiente(idx, { observaciones: e.target.value })}
              style={inputStyle}
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export default DocumentosDeLaSalida;

